<template>
    <div>
        <div class="header" :style="{
            backgroundColor: `rgba(255, 255, 255, ${bgOpacity})`,
            border: `${bgbd}`
        }">
            <div class="logobox">
                <img src="../assets/img/logo.svg" alt="" :style="{ width: screenWidth >= 1660 ? '263px' : '200px' }" class="logoimg2">
            </div>
            <div class="navbox" :style="{
            maxWidth: `${navMaxWidth}px`,
          
        }">
                <div v-for="(item, index) in tabsList" :key="index" class="nav-column">
                    <div v-for="(item2, index2) in item" :key="index2" class="nav" :class="{ active: item2.isActive }"
                        @click="toggleActive(item2)" :style="{ fontSize: screenWidth >= 1660 ? '15px' : '14px' }">
                        <div style="display: flex;align-items: center;">
                            <img v-if="item2.isActive" src="../assets/img/title-ico2.png" alt=""
                                style="width: 7px;margin-right: 4px;">
                            <img v-else src="../assets/img/title-ico.png" alt="" style="width: 7px;margin-right: 4px;">


                            {{ item2.name }}
                        </div>
                    </div>
                </div>



            </div>

            <div class="nav-right">
                <span @click="tozy" style="cursor: pointer;margin-top: 24px;">返回首页 &nbsp;</span>

            </div>

        </div>
    </div>
</template>

<script lang='ts' setup>
import { reactive, toRefs, ref, onMounted, watchEffect, computed, onUnmounted } from 'vue'
import { useRoute } from 'vue-router'
const route = useRoute()
import { useRouter } from "vue-router";

const router = useRouter();
let tabsList = reactive([
    [
        { name: '技术标准简介', path: '/introduction', isHovered: false, isActive: true, },
        { name: '联系我们', path: '/contactUs', isHovered: false, isActive: false, },
    ],
    [
        { name: '省公共服务平台', path: '/provincialServicePlatform', isHovered: false, isActive: false, },
        { name: '公共资源交易中心', path: '/tradingCenter', isHovered: false, isActive: false, },
        { name: '视频会议系统', path: '/venueVideoConferencingSystem', isHovered: false, isActive: false, },
        { name: '电子评标工具', path: '/bidEvaluationTools', isHovered: false, isActive: false, },
    ],
    [
        { name: '电子交易系统', path: '/tradingSystem', isHovered: false, isActive: false, },
        { name: '远程异地项目登记工具', path: '/remoteRegistrationTool', isHovered: false, isActive: false, },
        { name: '场所工位预约工具', path: '/placeReservationTool', isHovered: false, isActive: false, },
        { name: '专家库共享抽取工具', path: '/expertExtractionTool', isHovered: false, isActive: false, },
    ],
    [
        { name: '场地管理系统', path: '/venueManagementSystem', isHovered: false, isActive: false, },
        { name: '门禁系统', path: '/accessControlSystem', isHovered: false, isActive: false, },
        { name: '场地音视频监控工具', path: '/venueAudioAndVideoMonitoringTools', isHovered: false, isActive: false, },
    ],
    [
        { name: '评标专家库管理系统', path: '/bidEvaluationExpertDatabase', isHovered: false, isActive: false, },
        { name: '专家抽取终端', path: '/expertExtractionTerminal', isHovered: false, isActive: false, },
        { name: '场地专家签到工作台', path: '/expertSign', isHovered: false, isActive: false, },
        { name: '场地专家评标登录工作台', path: '/expertLogin', isHovered: false, isActive: false, },
    ],
    [
        { name: '远程异地评标目录服务组件', path: '/bidEvaluationComponent', isHovered: false, isActive: false, },
        { name: '评标专家库共享目录服务组件', path: '/expertLibraryComponent', isHovered: false, isActive: false, },
        { name: '共享组件标准接口联调', path: '/interfaceDebug', isHovered: false, isActive: false, },
    ],
    // [
    //     { name: '标准接口开发指南', path: '/interfaceGuide', isHovered: false, isActive: false, },
    // ],

    [

        // { name: '常见问题', path: '/problem', isHovered: false, isActive: false, },

    ],








])

let navMaxWidth = ref(1200);
const screenWidth = ref(document.body.clientWidth);
window.onresize = () => {
    console.log(document.body.clientWidth);
    screenWidth.value = document.body.clientWidth;
    if(screenWidth.value <= 1440){
        navMaxWidth.value = 1000;
    }
    if(screenWidth.value > 1440 && screenWidth.value <= 1920){
        navMaxWidth.value = 1200;
    }
    if(screenWidth.value > 1920){
        navMaxWidth.value = 1400;
    }
    
}

const bgOpacity = ref(0.6);
const bgbd = ref('none');
// 滚动事件处理函数
const handleScroll = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    bgOpacity.value = scrollTop < 577 ? 0.6 : 1; // 如果距离小于577，则透明度为0.6，否则为1
    bgbd.value = scrollTop > 577 ? '1px solid #E5E5E5' : 'none';
};

const toggleActive = (item: any) => {
    // 重置所有 tab 的 isActive 为 false
    tabsList.forEach(group => {
        group.forEach(tab => {
            tab.isActive = false;
            if (tab.path == item.path) {
                tab.isActive = true;
            }
        });
    });
    router.push({
        path: item.path,
    });

}



const tozy = () => {
    window.location.href = 'http://www.cebpubservice.com/'
}

watchEffect(() => {
    //tabsList.map((item: any) => {
    //     item.isActive = false;
    //     if (route.path.includes(item.path)) {
    //         item.isActive = true;
    //     }
    // })

    // if (route.path.includes('news')) {
    //    tabsList[0].isActive = true
    // }


    tabsList.forEach(group => {
        group.forEach(tab => {
            tab.isActive = false;
            if (route.path.includes(tab.path)) {
                tab.isActive = true;
            }
        });
    });



});


onMounted(() => {
    //tabsList.map((item: any) => {
    //     item.isActive = false;
    //     if (route.path.includes(item.path)) {
    //         item.isActive = true;
    //     }
    // })

    // if (route.path.includes('news')) {
    //    tabsList[0].isActive = true
    // }



    tabsList.forEach(group => {
        group.forEach(tab => {
            tab.isActive = false;
            if (route.path.includes(tab.path)) {
                tab.isActive = true;
            }
        });
    });


    window.addEventListener('scroll', handleScroll);


    screenWidth.value = document.body.clientWidth;
    if(screenWidth.value <= 1440){
        navMaxWidth.value = 1000;
    }
    if(screenWidth.value > 1440 && screenWidth.value <= 1920){
        navMaxWidth.value = 1200;
    }
    if(screenWidth.value > 1920){
        navMaxWidth.value = 1400;
    }


})

onUnmounted(() => {
    window.removeEventListener('scroll', handleScroll);
})


</script>
<style lang="scss" scoped>
.header {
    width: calc(100% - 60px);
    // width: 100%;
    // min-width: 1200px;
    /* height: 120px; */
    display: flex;
    // align-items: center;
    // justify-content: center;
    justify-content: space-between;


    position: fixed;
    top: 15px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 99;
    // background-color: rgba(255, 255, 255, 0.60);
    backdrop-filter: blur(8.250049591064453px);
    box-sizing: border-box;
    border-radius: 8px;

    padding: 0px 24px;

}


.logobox {
    /* display: flex;
    height: 64px;
    line-height: 64px;
    align-items: center; */
    /* margin-left: 50px; */
}

.logoimg {
    width: 444px;
    height: 35px;

}

.logoimg2 {
    // width: 200px;
    /* height: 38px; */
    margin-top: 24px;
}

.logotext {
    color: #333;
    text-align: justify;

    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;

}

.navbox {
    flex: 1;
    max-width: 1100px;
    display: flex;
    justify-content: space-between;
    // justify-content: center;

    overflow-x: hidden;
    overflow-y: hidden;
    /* height: 120px; */
    margin-right: 4px;
    margin-left: 4px;
    white-space: nowrap;
}


.nav-column {
    //  border-left: 1px solid #E6E6E6;
    padding: 20px 10px;
    position: relative;

    .left-line {
        width: 0px;
        height: 48px;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        border: 1px solid #E8EBF0;
    }
}


.nav-right {
    display: flex;
    // width: 160px;
    // min-width: 160px;
    color: #999;
    // text-align: center;
    text-align: right;

    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    float: right;
}

.nav {
    color: #282E3E;

    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    padding: 3px 0;
    // line-height: 26px;
}


.nav:hover {
    cursor: pointer;
    /* 鼠标移入时变为小手 */
    /* color: #409EFF; */

}

.nav.active {
    color: #3461FF;

    font-size: 14px;
    font-style: normal;
    // font-weight: 600;
}

.indicator {
    width: 100%;
    height: 1px;
    border: 1px solid #3461FF;
    position: absolute;
    bottom: -19px;
    background: #3461FF;
}

.nav.active .indicator {
    opacity: 1;
    /* 选中时指示器不透明度为1 */
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
    background: #DADADA !important;
    /* 滚动条滑块颜色 */
}
</style>